import { Component, OnInit, Input, ViewChild, Injector } from "@angular/core";
import { ProductService } from "src/app/services/product.service";
import { Router, ActivatedRoute, NavigationStart } from "@angular/router";
import {
  Product,
  ProductSearchRequest,
  AddToCartResponse,
} from "src/app/models/product";
import { CartService } from "src/app/services/cart.service";
import { ProductSuccessAddComponent } from "../product-success-add/product-success-add.component";
import { AlertComponent } from "src/app/alert/alert.component";
import { Principal } from "src/app/models/principal";
import { AdminHeaderComponent } from "src/app/layouts/admin-header/admin-header.component";
import * as firebase from "firebase";

declare var $: any;

@Component({
  selector: "app-list-product",
  templateUrl: "./list-product.component.html",
  styleUrls: ["./list-product.component.css"],
})
export class ListProductComponent implements OnInit {
  public products: Product[] = [];
  public selectedProduct: Product = null;
  public limit = 8;
  public off = 0;
  public canShowMore = false;
  public principal: Principal = null;
  public isLoadingProducts = false;
  public isEmptyProducts = false;

  @Input() ProductSearchQueryParam: ProductSearchRequest = new ProductSearchRequest();
  @ViewChild("addToCartModal") addToCartModal: ProductSuccessAddComponent;
  @ViewChild("alertComponent") alertComponent: AlertComponent;
  @ViewChild(AdminHeaderComponent) header: AdminHeaderComponent;

  constructor(
    public productService: ProductService,
    private cartService: CartService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    window.scrollTo(0, 0);
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          window.location.reload();
        }
      }
    });
  }

  ngOnInit() {
    firebase.analytics().logEvent("product_katalog");

    const data = this.route.snapshot.paramMap.get("data");
    if (data != null) {
      try {
        this.principal = JSON.parse(atob(data));
      } catch {
        this.principal = null;
      }
    }
    this.setDefaultQueryParam(this.principal);
    this.getProduct();

    $("body").on("keypress", "input[type=number][maxlength]", function (event) {
      var key = event.keyCode || event.charCode;
      var txtVal = $(this).val();
      var maxlength = $(this).attr("maxlength");
      if (key > 31 && (key < 48 || key > 57)) {
        return false;
      }
      if (txtVal.length == maxlength) {
        event.preventDefault();
        return false;
      }
      return true;
    });

    $("body").on("paste", "input[type=number][maxlength]", function (event) {
      return false;
    });
  }

  setDefaultQueryParam(principal: Principal) {
    this.route.queryParamMap.subscribe((params) => {
      this.ProductSearchQueryParam.src = params.get("keyword");
      this.ProductSearchQueryParam.lim = this.limit;
      this.ProductSearchQueryParam.off = this.off;
    });
    if (principal != null) {
      this.ProductSearchQueryParam.principal.push(principal);
    }
  }

  getProduct() {
    this.isEmptyProducts = false;
    this.isLoadingProducts = true;

    if (this.ProductSearchQueryParam.src !== '') {
      this.ProductSearchQueryParam.off = 0;
    }

    this.productService.getProducts(
      this.ProductSearchQueryParam,
      (data) => {
        this.getPromo(data);

        if (data.length > 0) {
          this.off += this.limit;
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }
        // if (data.length >= this.limit) {
        //   this.canShowMore = true;
        // }

        if (
          this.products.length === 0 &&
          this.ProductSearchQueryParam.off === 0
        ) {
          // if (this.ProductSearchQueryParam.src !== null && this.ProductSearchQueryParam.src.length > 0) {
          //   this.alertModal.show('', `Hasil pencarian untuk ${this.ProductSearchQueryParam.src} tidak ditemukan.`);
          // } else if (this.principal !== null) {
          //   this.alertModal.show('', `Hasil pencarian produk di principal ${this.principal.name} tidak ditemukan.`)
          // }

          this.isEmptyProducts = true;
        }
      },
      (err) => {
        this.isLoadingProducts = false;
        if (err.code !== 417) {
          this.alertComponent.show(err.code, err.message);
        }
      }
    );
  }

  // CR10
  getPromo(data) {
    this.products = data;
    let productCodes = [];

    this.products.forEach(item => {
      productCodes.push(item.code);
    });

    const paramPromo = {
      customerCode: JSON.parse(localStorage.getItem('user-profile')).customer_code,
      branch: JSON.parse(localStorage.getItem('user-profile')).branch_id,
      productCodes
    };

    this.productService.getProductsPromo(paramPromo, (response) => {
      const filt = response.filter(x => x.promotions);
      for (const item of filt) {
        let found = this.products.find(x => x.code === item.productCode);
        found.discount_list = item.promotions;
        found.label = item.label;
        found.max_show_discount = 2;
      }
      this.isLoadingProducts = false;
    }, (err) => {
      this.isLoadingProducts = false;
    });
  }

  onAddToCartSuccess(addToCartResponse: AddToCartResponse): void {
    console.log(addToCartResponse);
  }

  public addToCart(product: Product): void {
    firebase.analytics().logEvent("order_add_to_cart_catalog_product");

    if (product.ref_quantity > 0) {
      this.cartService.addToCart(
        product.code,
        product.unit_of_measure,
        product.ref_quantity,
        product.product_category,
        (data) => {
          this.addToCartModal.showWithData(product, true);
          this.header.loadCart();
        },
        (err) => {
          if (err.code === 417) {
            return;
          }

          this.addToCartModal.showWithData(product, false, err.message);
        }
      );
    } else {
      this.products.find((x) => x.code === product.code).alert_message =
        "Masukkan jumlah pesanan terlebih dahulu";
    }
  }

  public navigateToProductDetail(product: Product): void {
    product.composition_description = "";
    product.usability_description = "";
    product.how_to_use_description = "";

    this.router.navigate([`/detail-product/${btoa(JSON.stringify(product))}`]);
  }

  OnFilterSearchChanged(filterSearch: ProductSearchRequest): void {
    firebase.analytics().logEvent("product_filter_by_principal");

    this.canShowMore = false;
    this.products = [];
    this.isLoadingProducts = true;
    this.off = 0;

    this.ProductSearchQueryParam = filterSearch;
    this.getProduct();
  }

  onKeywordChanged(keyword: string): void {
    this.canShowMore = false;
    this.isEmptyProducts = false;
    this.products = [];
    this.isLoadingProducts = true;
    this.off = 0;

    this.ProductSearchQueryParam.src = keyword;
    this.getProduct();
  }

  showMore() {
    this.isLoadingProducts = true;
    this.canShowMore = false;
    this.setDefaultQueryParam(this.principal);

    this.productService.getProducts(
      this.ProductSearchQueryParam,
      (data) => {
        if (data.length > 0) {
          data.forEach((item) => {
            this.products.push(item);
          });

          this.getPromo(this.products);
          this.canShowMore = true;
        }

        this.off += this.limit;
        this.isLoadingProducts = false;

        // if (data.length >= this.limit) {
        //   this.canShowMore = true;
        // }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  openDetailPromo(id: string) {
    const arrow = document.getElementById(`arrow_detail_${id}`);
    if (arrow) {
      arrow.classList.toggle("rotate");
    }

    const panel = document.getElementById(`panel_${id}`);
    if (panel) {
      const disp = panel.style.display;
      panel.style.display = (disp === 'block') ? 'none' : 'block';
    }

    const showMore = document.getElementById(`show_more_${id}`);
    if (showMore) {
      showMore.style.display = 'block';
    }

    let found = this.products.find(x => x.code === id);
    found.max_show_discount = 2;
  }

  showMoreDiscountList(id: string) {
    const showMore = document.getElementById(`show_more_${id}`);
    if (showMore) {
      showMore.style.display = 'none';
    }

    let found = this.products.find(x => x.code === id);
    found.max_show_discount = 1000;
  }
}
